export default __webpack_public_path__ + "static/media/jugad0.96660096.png";